var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdb-a-notification image-url=\"$ctrl.imageUrl\"\u003E\u003Cnotification-title ng-bind=\"$ctrl.title\" ng-if=\"$ctrl.title\"\u003E\u003C\u002Fnotification-title\u003E\u003Cnotification-content ng-bind=\"$ctrl.message\"\u003E\u003C\u002Fnotification-content\u003E\u003C\u002Fdb-a-notification\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/application/component/notifications/component/text-notification/text-notification.tpl.pug
// module id = RhrS
// module chunks = 0